var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3063 8.00977H4.69202C3.95926 8.00977 3.36523 8.60379 3.36523 9.33655V17.2973C3.36523 18.0301 3.95926 18.6241 4.69202 18.6241H15.3063C16.0391 18.6241 16.6331 18.0301 16.6331 17.2973V9.33655C16.6331 8.60379 16.0391 8.00977 15.3063 8.00977Z",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.643 8.0099V6.01973C14.643 4.78812 14.1538 3.60697 13.2828 2.7361C12.412 1.86523 11.2308 1.37598 9.99922 1.37598C8.76762 1.37598 7.58646 1.86523 6.7156 2.7361C5.84472 3.60697 5.35547 4.78812 5.35547 6.01973V8.0099",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99933 13.9801C10.3657 13.9801 10.6627 13.6831 10.6627 13.3167C10.6627 12.9503 10.3657 12.6533 9.99933 12.6533C9.63295 12.6533 9.33594 12.9503 9.33594 13.3167C9.33594 13.6831 9.63295 13.9801 9.99933 13.9801Z",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1f1b12a53bbcad2f263e45625269c9aa.svg";
export { ForwardRef as ReactComponent };